// Frog Posters — carrousel des recommandations panier
// Chargé une seule fois (voir cart-drawer.liquid), en dehors de la zone
// qui se rafraîchit en AJAX à chaque ajout/suppression d'article.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-fp-reco-prev], [data-fp-reco-next]');
  if (!btn) return;
  var section = btn.closest('.fp-cart-reco');
  var track = section && section.querySelector('[data-fp-reco-track]');
  if (!track) return;
  var item = track.querySelector('.fp-cart-reco__item');
  var step = item ? item.getBoundingClientRect().width + 12 : 150;
  track.scrollBy({
    left: btn.hasAttribute('data-fp-reco-prev') ? -step : step,
    behavior: 'smooth',
  });
});